const development_tenant = {
    notification: 'Estás em modo de desenvolvimento',
};
export default Object.freeze(development_tenant);
